// extracted by mini-css-extract-plugin
module.exports = {"scrollWrapper":"horizontal-scroll_scrollWrapper__DaB_l","scroll":"horizontal-scroll_scroll__3Ef24"};